import { useState, useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { SHOW_STATUS_BANNER as FALLBACK_ENABLED, STATUS_BANNER_MESSAGE as FALLBACK_MESSAGE } from "@/config/statusBanner";

const STORAGE_KEY = "cloud-status-banner-dismissed";

export const CloudStatusBanner = () => {
  const [dismissed, setDismissed] = useState(() =>
    sessionStorage.getItem(STORAGE_KEY) === "true"
  );
  const [enabled, setEnabled] = useState(FALLBACK_ENABLED);
  const [message, setMessage] = useState(FALLBACK_MESSAGE);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const { data } = await supabase
          .from("platform_settings" as any)
          .select("value")
          .eq("key", "status_banner")
          .single();
        if (data) {
          const val = (data as any).value as { enabled?: boolean; message?: string };
          setEnabled(val.enabled ?? FALLBACK_ENABLED);
          setMessage(val.message ?? FALLBACK_MESSAGE);
        }
      } catch {
        // Use fallback values
      }
    };
    fetchBanner();
  }, []);

  if (!enabled || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, "true");
    setDismissed(true);
  };

  return (
    <div className="w-full bg-amber-500/15 border-b border-amber-500/30 text-amber-900 dark:text-amber-200">
      <div className="container max-w-6xl mx-auto px-4 py-2.5 flex items-center gap-3">
        <AlertTriangle className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
        <p className="text-sm flex-1">
          {message}{" "}
          <Link to="/status" className="underline underline-offset-2 font-medium hover:opacity-80 transition-opacity">
            View status
          </Link>
        </p>
        <button
          onClick={handleDismiss}
          aria-label="Dismiss"
          className="shrink-0 rounded-md p-1 hover:bg-amber-500/20 transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
